export default __webpack_public_path__ + "static/media/background.c7816bb6.png";